/* eslint-disable import/prefer-default-export */

// Runtime config: SPAs read these from /env-config.js (window._env_) at runtime,
// NOT from build-time process.env (empty in the deployed bundle). Mirrors the
// getEnv pattern in docAgentNormalizer.js / agenticApiClient.js.
const getEnv = (key) => window._env_?.[key] ?? process.env[key];

const getAgenticBaseUrl = () => {
  const raw = (getEnv("REACT_APP_AGENTIC_API_BASE_URL") || "").trim();
  if (!raw) return "";
  if (/^https?:\/\//i.test(raw)) return raw.replace(/\/+$/, "");
  return `https://${raw.replace(/\/+$/, "")}`;
};

const getAgenticCode = () => (getEnv("REACT_APP_AGENTIC_API_CODE")
  || getEnv("REACT_APP_AGENTIC_API_FUNCTION_KEY")
  || "").trim();

// Builds the BFF /api/documents/images URL the DocumentViewerModal iframe needs
// (raw blob paths are not directly viewable — no SAS / ORB-blocked). Same
// endpoint + shape the Document Quality report uses.
const buildFileUrl = (caseId, fileName) => {
  const base = getAgenticBaseUrl();
  if (!base || !fileName) return null;
  const code = getAgenticCode();
  const url = `${base}/api/documents/images?case_id=${encodeURIComponent(caseId)}&filename=${encodeURIComponent(fileName)}`;
  return code ? `${url}&code=${encodeURIComponent(code)}` : url;
};

// Builds the list the report uses to make a markdown cell clickable when its
// text matches a known filename. Data-driven (like the other agents), so it
// covers every document regardless of file extension. The eligibility response
// exposes documents under different keys depending on the agent version, so we
// read all of them:
//   - output_text.document_metadata[]                         (documentName/blobPath)
//   - output_text.validate_required_documents.documents_validated[] (file_name/blob_path)
const mapEligibilityDocuments = (response) => {
  const out = response?.output_text || {};

  const caseId = (out.validate_required_documents?.case_id
    || out.case_data?.CaseID
    || response?.case_id
    || out.canopy_extraction?.[0]?.case_id
    || "").trim();

  const rawDocs = [
    ...(out.document_metadata || []),
    ...(out.validate_required_documents?.documents_validated || []),
  ];

  const byFileName = new Map();

  rawDocs.forEach((doc) => {
    const fileName = doc.documentName || doc.document_name || doc.file_name || null;
    if (!fileName || byFileName.has(fileName)) return;

    const fileUrl = buildFileUrl((doc.case_id || caseId).trim(), fileName);
    if (!fileUrl) return;

    byFileName.set(fileName, {
      fileName,
      documentName: doc.documentName || doc.document_name || fileName,
      fileUrl,
    });
  });

  return Array.from(byFileName.values());
};

export function normalizeEligibilityResponse(response) {
  return {
    text: response?.response || response?.message || "",
    threadId: response?.thread_id,
    raw: response,
    documents: mapEligibilityDocuments(response),
  };
}
